$(() => {
    $('.gh_ham_burger_icon').click(function (e) {
        $(".gh_ham_burger_container").toggle();
        $(".main_nav_hamburger").toggleClass('is-open');
    });
});



// WEBPACK FOOTER //
// Glasshouse/Core/js/navigation-hamburger.js